module.exports = __webpack_public_path__ + "static/img/bg_business_h2.4369d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/bg_business_h2.png
// module id = +kCm
// module chunks = 3